import {parseQueryString} from './query.utils';

const _q = parseQueryString();


function isMobile() {
  // Test bypass (matchMedia is not supported in jsdom)
  if (window == null || window.matchMedia == null) {
    return false;
  }
  return 'im' in _q || window.matchMedia('only screen and (max-width: 480px)').matches;
}

function isTablet() {
  // Test bypass (matchMedia is not supported in jsdom)
  if (window == null || window.matchMedia == null) {
    return false;
  }
  return 'it' in _q || window.matchMedia('only screen and (max-width: 768px)').matches;
}

const IS_MOBILE = isMobile();
const IS_TABLET = isTablet();

export {
  IS_MOBILE,
  IS_TABLET,
};
